module.exports = __webpack_public_path__ + "static/media/book.4e122bc9.gif";